const svg = `
   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 17L1 7.00004C1 5.89548 1.89543 5.00005 2.99999 5.00004L21.7687 5C22.4487 5.00003 23 5.55133 23 6.23139V14.4971L23 17C23 18.1046 22.1046 19 21 19H16.1168H12L3 19C1.89543 19 1 18.1046 1 17Z" stroke="#5925DC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.17188 4.92188L8.17188 18.9219" stroke="#5925DC" stroke-width="1.5"/>
        <path d="M0.722656 12.0234L8.35598 12.0234" stroke="#5925DC" stroke-width="1.5"/>
        <path d="M16 12H23" stroke="#5925DC" stroke-width="1.5"/>
        <path d="M16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5L16 5L16.75 5ZM16 5L15.25 5L15.25 19L16 19L16.75 19L16.75 5L16 5Z" fill="#5925DC"/>
        <path d="M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5L12 5L12.75 5ZM12 5L11.25 5L11.25 19L12 19L12.75 19L12.75 5L12 5Z" fill="#5925DC"/>
    </svg>
`;

const ReservationCourtIcon = `data:image/svg+xml,${encodeURIComponent(svg)}`;

export default ReservationCourtIcon;
